import { makeStyles } from '@material-ui/core/styles'
import { reExportedColors, Text } from '../1elements'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import FormTextField from './FormTextField'
import SetToDefaultButton from '../1elements/Buttons/IconButtons/SetToDefaultButton'
import DragIconButton from '../1elements/Buttons/IconButtons/DragIconButton'
import { Reorder, useDragControls } from 'framer-motion'
import ShowHideButton from '../1elements/Buttons/IconButtons/ShowHideButton'

const AccordionBase = ({
  hideShowHIdeButton,
  hideDragButton,
  children,
  label,
  className,
  isOpen,
  setIsOpen,
  admin,
  updateCardLabel,
  data,
  resetToDefault,
  layoutDefaultData,
  index,
  isCardDirty,
  multipleColumns,
  updateCardLabelMultipleColumns,
  toggleIsHiddenCard
}) => {
  const controls = useDragControls()
  const labelArray = multipleColumns ? JSON.parse(label) : []
  const numberOfColumns = labelArray.length
  const classes = useStyles({ numberOfColumns })

  const toggleIsOpen = () => {
    setIsOpen(prevState => !prevState)
  }

  if (admin) {
    if (data === undefined) {
      return ''
    }
    const { cardId } = data
    return (
      <Reorder.Item
        key={cardId}
        value={data}
        className={`${classes.root} ${className} ${
          data.isHidden && classes.hidden
        }`}
        drag
        dragListener={false}
        dragControls={controls}
      >
        <Accordion className={classes.innerDiv} expanded={isOpen}>
          <AccordionSummary
            className={`${classes.accordionSummary} ${
              multipleColumns && classes.accordionSummaryGrid
            } ${!hideShowHIdeButton && classes.accordionSummaryAdmin}`}
            expandIcon={
              <ExpandMoreIcon
                className={classes.arrowIcon}
                onClick={toggleIsOpen}
              />
            }
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            {!hideShowHIdeButton && (
              <ShowHideButton
                className={classes.showHideButton}
                show={!data.isHidden}
                toggleIsHidden={() => toggleIsHiddenCard(index)}
              />
            )}
            {isCardDirty && (
              <SetToDefaultButton
                onClick={() => resetToDefault(index, data.cardId)}
                className={classes.resetToDefaultButton}
              />
            )}

            {!hideDragButton && (
              <DragIconButton
                controls={controls}
                className={classes.dragIcon}
              />
            )}
            {multipleColumns ? (
              labelArray.map((label, labelIndex) => (
                <FormTextField
                  key={label + labelIndex}
                  value={
                    label ||
                    (Array.isArray(layoutDefaultData) &&
                      JSON.parse(
                        layoutDefaultData.filter(
                          defaultCard => defaultCard.cardId === cardId
                        )[0].label
                      )[labelIndex]) ||
                    ''
                  }
                  onChange={newValue =>
                    updateCardLabelMultipleColumns(index, labelIndex, newValue)
                  }
                  className={`${classes.cardLabelField} ${classes.cardLabelFieldMultiple}`}
                />
              ))
            ) : (
              <FormTextField
                value={
                  label ||
                  (Array.isArray(layoutDefaultData) &&
                    layoutDefaultData.filter(
                      defaultCard => defaultCard.cardId === cardId
                    )[0].label) ||
                  ''
                }
                onChange={updateCardLabel}
                className={classes.cardLabelField}
              />
            )}
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            {children}
          </AccordionDetails>
        </Accordion>
      </Reorder.Item>
    )
  }

  return (
    <Accordion className={`${classes.innerDiv} ${className}`} expanded={isOpen}>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<ExpandMoreIcon className={classes.arrowIcon} />}
        aria-controls='panel1a-content'
        id='panel1a-header'
        onClick={toggleIsOpen}
      >
        {multipleColumns ? (
          labelArray.map((label, labelIndex) => (
            <Text key={labelIndex} type='h2' className={classes.header}>
              {label || <span>&nbsp;</span>}
            </Text>
          ))
        ) : (
          <Text type='h2' className={classes.header}>
            {label || <span>&nbsp;</span>}
          </Text>
        )}
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionBase

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative'
  },
  innerDiv: {
    // height: '100%',
    marginTop: '0 !important',
    boxShadow: 'none !important',
    // backgroundColor: `${theme.palette.quaternary.main} !important`,
    '&::before': {
      display: 'none !important'
    }
  },
  arrowIcon: {
    // color: theme.palette.primary.accent,
    cursor: 'pointer'
  },
  accordionSummary: {
    position: 'relative',
    userSelect: 'none',
    minHeight: '30px !important',
    cursor: 'default !important',
    borderBottom: `1px solid ${reExportedColors.DARK_GREY} !important`, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    '& .MuiButtonBase-root': {
      padding: '0 12px'
    },
    '& .MuiAccordionSummary-content': {
      margin: '5px 0 !important'
    }
  },
  accordionSummaryAdmin: {
    paddingLeft: '35px !important'
  },
  accordionSummaryGrid: {
    '&>div': {
      display: 'grid',
      gridTemplateColumns: props => `repeat(${props.numberOfColumns}, 1fr)`,
      gridTemplateRows: '1fr'
    }
  },
  accordionDetails: {
    marginLeft: 10,

    '&>ul': {
      ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
      background:
        'linear-gradient(white, rgba(255,255,255,0)), linear-gradient(rgba(255,255,255,0), white 70%) 0 100%, radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.2), rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0)) 0 100%',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'white',
      backgroundSize: '100% 40px, 100% 40px, 100% 5px, 100% 5px',
      backgroundAttachment: 'local, local, scroll, scroll'
    }
  },
  cardLabelField: {
    width: 250,
    userSelect: 'none',
    '& input': {
      fontWeight: 500
    }
  },
  resetToDefaultButton: {
    position: 'absolute',
    right: 35,
    top: 11,
    '& .MuiButtonBase-root': {
      padding: 0
    }
  },
  dragIcon: {
    position: 'absolute',
    right: 10,
    top: 10
  },
  header: {
    width: '100%'
  },
  showHideButton: {
    position: 'absolute',
    padding: '0 !important',
    left: 5,
    top: 5
  },
  hidden: {
    opacity: 0.5
  },
  cardLabelFieldMultiple: {
    '&:last-of-type': {
      justifySelf: 'end',
      width: 130,
      marginRight: 50
    }
  }
}))
